/* eslint-disable no-param-reassign */
import axios, { CancelToken, isCancel } from 'axios';

export const getNsdApiBaseUrl = () => {
  let nsdApiBaseUrl = process.env.REACT_APP_COMMON_SERVICES_API;
  return nsdApiBaseUrl;
};

const getAPIHeader = () => {
  let header;
  header = {
    common: {
      'Ocp-Apim-Subscription-Key': process.env.REACT_APP_NSD_API_KEY,
      'Suite-Identifier': process.env.REACT_APP_SUITE_IDENTIFIER
    }
  };

  return header;
};
const nsdAPIHeader = getAPIHeader();

const instance = axios.create({
  headers: nsdAPIHeader,
  withCredentials: true,
  baseURL: getNsdApiBaseUrl()
});

instance.interceptors.request.use(
  config => {
    return config;
  },
  error => Promise.reject(error)
);

export default instance;
export { CancelToken, isCancel };
